module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sfboxl2"
  }, [_c('div', {
    staticClass: "wfull"
  }, [_c('div', {
    staticClass: "hotfbox"
  }, [_c('div', {
    staticClass: "after-sales-wfull-left",
    attrs: {
      "id": "contentbox"
    }
  }, [_c('div', {
    staticClass: "aswl-tech"
  }, [_c('span', [_vm._v("售后服务")])]), _vm._v(" "), _c('div', {
    staticClass: "aswl-tech-cont"
  }, [_c('div', {
    staticClass: "aswl-tech-cont-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/shouhou.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "aswl-tech-cont-box-div"
  }, [_c('span', {
    staticClass: "iconfontyyy ydy"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/ren.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('h2', [_vm._v("1对1专属顾问及时回复")]), _vm._v(" "), _c('p', [_vm._v("1对1技术支持")]), _vm._v(" "), _c('p', [_vm._v("强大的服务团队")]), _vm._v(" "), _c('p', [_vm._v("QQ：309816335 ")]), _vm._v(" "), _c('p', [_vm._v("微信：haochihaohe2012 ")]), _vm._v(" "), _c('p', [_vm._v("传真：021-39927292 ")]), _vm._v(" "), _c('p', [_vm._v("邮箱：cxg@qikesh.com‍")]), _vm._v(" "), _c('p', [_vm._v("时间：周一到周五 09：00-18：00(法定节假日除外)")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-672c228a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 201
// module chunks = 1